// Inline SVG flags so they render identically on every OS/browser. Flag emoji
// (🇬🇧 🇫🇷) don't display on Windows Chrome, so we draw them instead.

export const FlagFR = ({ className = 'h-3.5 w-5' }) => (
    <svg viewBox="0 0 3 2" className={`rounded-[2px] shrink-0 ${className}`} aria-hidden="true">
        <rect width="3" height="2" fill="#fff" />
        <rect width="1" height="2" fill="#0055A4" />
        <rect width="1" height="2" x="2" fill="#EF4135" />
    </svg>
);

export const FlagGB = ({ className = 'h-3.5 w-5' }) => (
    <svg viewBox="0 0 60 30" className={`rounded-[2px] shrink-0 ${className}`} aria-hidden="true">
        <clipPath id="flag-gb-clip"><path d="M0,0 v30 h60 v-30 z" /></clipPath>
        <clipPath id="flag-gb-tri"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
        <g clipPath="url(#flag-gb-clip)">
            <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
            <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#flag-gb-tri)" stroke="#C8102E" strokeWidth="4" />
            <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
            <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
        </g>
    </svg>
);
